export const LONG_ANIMATION_DURATION_SECONDS = 15;